import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    Skeleton,
    Toaster,
    useToast,
} from "@postcheesy/ui-lib/molecules";
import React, { useEffect, useState } from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { useNavigate } from "react-router-dom";
import { Button } from "@postcheesy/ui-lib/atoms";
import resendConfirmationEmail from "../../api/resendConfirmationEmail";
import { useUser } from "../../resources/contexts/UserContext";
import { ROUTES } from "../../resources/constants/routes";
import { LogoutButton } from "../../components/ui/LogoutButton";

export const ConfirmEmail: React.FC = () => {
    const { toast } = useToast();
    const { user, refreshUser, loading, isUserChecked } = useUser();
    const [resendCooldown, setResendCooldown] = useState(15);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user && !loading) {
            refreshUser();
        }
    }, [user, loading, refreshUser]);

    useEffect(() => {
        if (isUserChecked && user?.isEmailConfirmed) {
            navigate(user.isPhoneConfirmed ? ROUTES.DASHBOARD : ROUTES.VERIFY_PHONE, { replace: true });
        }
    }, [user, isUserChecked]);

    useEffect(() => {
        if (resendCooldown > 0) {
            const timeout = setTimeout(() => {
                setResendCooldown(resendCooldown - 1);
            }, 1000);

            return () => clearTimeout(timeout);
        }
    }, [resendCooldown]);

    const handleResendEmail = async () => {
        const email = user?.email || localStorage.getItem("email");
        if (!email || resendCooldown > 0) return;

        try {
            await resendConfirmationEmail(email);
            toast({
                title: "Succès",
                description: "Votre lien de confirmation a été renvoyé avec succès.",
                variant: "default",
            });

            setResendCooldown(15);
        } catch (error) {
            // console.error("Erreur lors de l'envoi du lien de confirmation:", error);
        }
    };

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen">
                <Skeleton className="w-16 h-16 rounded-full" />
            </div>
        );
    }

    return (
        <Layout>
            <Toaster />
            <Container className="py-6">
                <div className="relative mx-auto grid h-full w-fit grid-cols-1 items-start justify-center">
                    <section className="lg:my-18 container mx-auto my-12 h-fit max-w-xl py-8 md:my-12 2xl:my-32">
                        <LogoutButton variant="link">
                            {"< Retourner à la page de connexion"}
                        </LogoutButton>
                        <Card className="w-full">
                            <CardHeader>
                                <CardTitle className="text-2xl">
                                    {"Confirmation de votre email"}
                                </CardTitle>
                                <CardDescription>
                                    {"Un email de confirmation vous a été envoyé. Veuillez vérifier votre boîte de réception."}
                                </CardDescription>
                            </CardHeader>
                            <CardContent className="flex flex-col gap-4 justify-center">
                                <Button
                                    onClick={handleResendEmail}
                                    disabled={resendCooldown > 0}
                                >
                                    {resendCooldown > 0 ? `Lien dans ${resendCooldown}s` : "Me renvoyer un lien de confirmation"}
                                </Button>
                            </CardContent>
                        </Card>
                    </section>
                </div>
            </Container>
        </Layout>
    );
};